<script lang="ts">
  import type { Target } from '@shared/types';
  import { Avatar } from '@shared/ui/avatar';

  import { formatWalletId } from '@entities/wallet/libs';

  import Chip from './chip.svelte';

  export let walletId: string;
  export let href: string | undefined = undefined;
  export let target: Target | undefined = undefined;
</script>

<div class="flex items-center">
  <Chip variant="secondary" size="sm" {href} {target}>
    <div class="flex items-center gap-1">
      <Avatar wallet="{walletId}" width="{24}" />
      <span class="font-roboto px-1 font-medium">{formatWalletId(walletId)}</span>
    </div>
  </Chip>
</div>
